import { createSelector } from "@reduxjs/toolkit";
import { isPast } from "date-fns";

import { selectCurrentUserId } from "../local";

import { selectIsInPersonClass } from "./info";

import { selectIsPresentationView } from ".";

import { CapabilityType, RootState } from "shared/types";

export const selectUserIdsWithCapability = (capability: CapabilityType) => (state: RootState) =>
  state.classroom.client.capabilities[capability] || [];

export const selectCurrentUserCanResetSession = () => (state: RootState) => {
  const currentUserId = selectCurrentUserId()(state);
  const canAlwaysResetClass = (
    state.classroom.client.capabilities.canAlwaysResetClass || []
  ).includes(currentUserId);
  const canResetClass = (state.classroom.client.capabilities.canResetClass || []).includes(
    currentUserId,
  );
  const classInfo = state.classroom.client.info;
  const classStartTime = classInfo.date && new Date(classInfo.date);
  const classHasStarted = !!(classStartTime && isPast(classStartTime));
  return canAlwaysResetClass || (canResetClass && !classHasStarted);
};

export const selectCurrentUserCanPlaySounds = () =>
  createSelector(
    [
      selectIsInPersonClass(),
      selectCurrentUserId(),
      selectUserIdsWithCapability(CapabilityType.CAN_CONTROL_CLASSROOM),
      selectIsPresentationView(),
    ],
    (isInPerson, userId, canControlClassroomList, isPresentationView) => {
      return !isInPerson || (canControlClassroomList?.includes(userId) && !isPresentationView);
    },
  );

export const selectStudentsCanDraw = () => (state: RootState) =>
  state.classroom.client.enable_student_drawing ||
  !!state.classroom.client.active_breakout_session_id;
